<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1">
        <span slot="tab">
      <a-icon type="cloud-upload"/>
          {{$t('Documentos de Desvinculación o Retiro')}}
    </span>
      <a-card>
        <g-master :name="master.endpoint"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  :actions="master.actions"
                  @action="masterAction"
                  ref="masterComponent"
        >
        </g-master>
        <a-modal title="Cargue de doc."
                 :visible="modalDocObligatorioVisible"
                 @ok="aceptarModalDocObligatorio"
                 :confirmLoading="modalDocObligatorioLoading"
                 @cancel="cancelarModalDocObligatorio"
                 :dialogStyle="{top: '20px'}"
                 width="90%">
          <a-spin :spinning="modalDocObligatorioLoading">
            <a-row :gutter="[16,16]">
              <a-form-model :model="formData">
                <template v-for="doc in documentosSeleccionados">
                  <a-col :md="12" style="max-height: 28px; overflow: hidden">
                    <a-tooltip title="Eliminar" v-if="doc.eliminable">
                      <a-icon type="delete" style="color:red;"
                              @click="eliminarDocumento(doc.id_h_lookup)"/>
                    </a-tooltip>
                    <a-tooltip title="Requerido" v-else>
                      <a-badge status="error"/>
                    </a-tooltip>
                    <a-tooltip :title="doc.description">
                      {{doc.description}}
                    </a-tooltip>
                  </a-col>
                  <a-col :md="1" style="max-height: 40px; overflow: hidden">
                    <a-upload
                      name="file"
                      :multiple="false"
                      :beforeUpload="(file, fileList) => beforeFileUpload(doc.id_h_lookup, file)"
                      :remove="(file, fileList) => removeFileUpload(doc.id_h_lookup, file)">
                      <a-button>
                        <a-icon type="upload" v-if="formData['d_'+doc.id_h_lookup+'_file'] !== true"></a-icon>
                        <a-icon type="check" v-if="formData['d_'+doc.id_h_lookup+'_file'] === true"
                                style="color: green"></a-icon>
                      </a-button>
                    </a-upload>
                  </a-col>
                </template>
              </a-form-model>
            </a-row>
          </a-spin>
        </a-modal>
      </a-card>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        modalDocObligatorioVisible: false,
        modalDocObligatorioLoading: false,
        formData: {},
        formDataFiles: {},
        documentosSeleccionados: [],
        docSeleccionado: undefined,
        docSeleccionadoObj: {},
        docSeleccionadoObj2: {},
        loadingBtns: {},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'doc_desvinculacion',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Documento', dataIndex: 'h_type_doc', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ],
            actions: {
              actions: [
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            }
          },
          actions: [
            {
              name: 'docObligatorio',
              text: 'Cargar documentos',
              permisos: [],
              props: {icon: 'plus', type: 'button'}
            }
          ]
        }
      }
    },
    props: ['empleadoseleccionado'],
    mounted () {
      this.httpClient = new HttpUtil('desvinculacion/cargar_documentos_obligatorios')
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    },
    methods: {
      beforeFileUpload (tipoDoc, file) {
        this.formData['d_' + tipoDoc + '_file'] = true
        this.formDataFiles['d_' + tipoDoc] = file
        this.$forceUpdate()
        return false
      },
      removeFileUpload (tipoDoc, file) {
        this.formData['d_' + tipoDoc + '_file'] = false
        this.formDataFiles['d_' + tipoDoc] = undefined
        this.$forceUpdate()
      },
      masterAction (action) {
        switch (action.action) {
          case 'docObligatorio':
            this.modalDocObligatorioVisible = true
            this.cargarDocumentosRequeridos()
            this.formData = {}
            this.formDataFiles = {}
            break
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('desvinculacion/id_doc', {
          id: record.id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      cargarDocumentosRequeridos () {
        this.modalDocObligatorioLoading = true
        this.httpClient.getInstance().get('desvinculacion/documentos_obligatorios', {
          params: {
            id_emp: this.empleadoseleccionado
          }
        })
          .then(response => {
            this.documentosSeleccionados = []
            response.data.map(d => {
              d.eliminable = false
              this.documentosSeleccionados.push(d)
            })
          })
          .catch(() => {
            this.documentosSeleccionados = []
          })
          .then(() => {
            this.modalDocObligatorioLoading = false
          })
      },
      aceptarModalDocObligatorio () {
        let requestData = new FormData()
        requestData.append('id_emp', this.empleadoseleccionado)

        if (this.modalDocObligatorioLoading) return
        /* valida todos los documentos obligatorios */
        for (let i = 0; i < this.documentosSeleccionados.length; i++) {
          const documentosSeleccionado = this.documentosSeleccionados[i]
          if (!this.formData['d_' + documentosSeleccionado.id_h_lookup + '_file']) {
            Mensajes.error('Error', 'Por favor cargue todos los documentos seleccionados')
            return
          }
          /* agrego los campos */
          requestData.append('tipo_documentos_enviados[]', documentosSeleccionado.id_h_lookup)
          /* agrego el archivo */
          let fileProp = 'd_' + documentosSeleccionado.id_h_lookup
          if (this.formData[fileProp + '_file']) {
            requestData.append(fileProp + '_file', this.formDataFiles[fileProp])
          }
        }
        /* Prepara el upload de todos los documentos */
        this.modalDocObligatorioLoading = true
        this.httpClient.create(requestData,
          (response) => {
            Mensajes.success('Correcto', 'Se cargaron los documentos correctamente')
            this.modalDocObligatorioVisible = false
            this.$refs.masterComponent.$refs.datatable.loadData()
          }, () => {
            Mensajes.error('Error', 'No fue posible cargar los documentos.')
          })
          .then(() => {
            this.modalDocObligatorioLoading = false
          })
      },
      cancelarModalDocObligatorio () {
        if (this.modalDocObligatorioLoading) return
        this.modalDocObligatorioVisible = false
      },
      eliminarDocumento (id) {
        let idx = -1
        for (let i = 0; i < this.documentosSeleccionados.length; i++) {
          const documentosSeleccionado = this.documentosSeleccionados[i]
          if (documentosSeleccionado.id_h_lookup === id) {
            idx = i
            break
          }
        }
        if (idx > -1) {
          this.documentosSeleccionados.splice(idx, 1)
        }
      },
      agregarDocumento () {
        if (!JsUtils.isEmpty(this.docSeleccionadoObj)) {
          let existe = false
          for (let i = 0; i < this.documentosSeleccionados.length; i++) {
            const documentosSeleccionado = this.documentosSeleccionados[i]
            if (documentosSeleccionado.id_h_lookup === this.docSeleccionado) {
              existe = true
              break
            }
          }
          if (!existe) {
            this.documentosSeleccionados.push({
              eliminable: true,
              description: this.docSeleccionadoObj.text,
              id_h_lookup: this.docSeleccionadoObj.value,
              ...this.docSeleccionadoObj
            })
          }
          this.docSeleccionado = undefined
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeCargueDocDesvinculacion.vue